import React, { Fragment, useEffect } from "react";
import {
    Button,
    Col,
    Form,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    InputGroup,
    Row,
    ListGroup,
    InputGroupText,
    Pagination,
    PaginationItem,
    PaginationLink,
    Alert
} from "reactstrap";

import { useState } from "react";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import { ConvertDate } from "../../Function/ConvertDate";
import { FetchAxiosGet, FetchAxiosPost } from "../../../api/axios";
import Select from 'react-select';
import ModalUser from "../../SetData/SetCommander/ModalUser";
import { useInsertConText } from "../../Context/InsertContext";
import MyThaiDatePick from "../../../components/Common/ThaiDatePicker";
import MyDatePicker from "../../../components/Common/MyDateTimePicker";
import MyTimePick from "../../../components/Common/TimePicker";
import { ListItem } from "@mui/material";
import LoadingData from "../../TESTPage/LoadingData";
import NewThaiDatePicker from "../../../components/Common/NewThaiDatePicker";

const baseURL = process.env.REACT_APP_API_CORS;

const ModalBorrowTable = ({
    getBorrowDataTable,
    dataEdit,
    modalState,
    setModalState,
    user,
    openBorrow,
    toggleModal,
    setDataEdit,
}) => {
    const token = GetCookieToken("userToken");
    const userData = GetCookieData("userData");
    const filterSubAdmin = userData?.positionSubAdmin?.map(i => i.type_sub_admin);
    //ข้อมูลของ add Data
    const [data, setData] = React.useState({
        users_name_borrow: user.user_name,
        users_id_borrow: user.user_id,
        date_borrow: new Date(),
        date_return: new Date(),
        equipment_id: [],
        class_name: "",
        remark_borrow: "",
        remark_return: "",
        status: 0,
    });
    const [inputSearchClass, setInputSearchClass] = useState("");
    const [checkEquipment, setCheckEquipment] = useState(false);
    const [equipmentClass, setEquipmentClass] = useState([]);
    const [openModal, setOpenModal] = useState(false)
    const [alertModal, setAlertModal] = useState(false)
    const [inputSearch, setInputSearch] = useState("");
    const [keyWord, setKeyWord] = useState("");
    const [equipment, setEquipment] = useState([]);
    const [searchChangeInput, setSearchChangeInput] = useState("")
    const [prevValue, setPrevValue] = useState(inputSearchClass);
    const [prevValue2, setPrevValue2] = useState(searchChangeInput);
    const [menuShow, setMenuShow] = useState(false);
    const [menuShow2, setMenuShow2] = useState(false);
    const [changeEquipment, setChangeEquipment] = useState([])
    const [allEquipment, setAllEquipment] = useState([])
    const [checkChangeEquipment, setCheckChangeEquipment] = useState(false)
    const [checkReplaceEquipment, setCheckReplaceEquipment] = useState([])
    const [dataInfo, setDataInfo] = useState(null)
    const [validatedObj, setValidatedObj] = useState({
        valid_dateBorw: null,
        valid_dateRetrn: null,
        valid_item: null
    });

    const [submit, setSubmit] = useState(false)
    const [currentpage, setCurrentpage] = useState(1)
    const [dataloading, setDataloading] = useState(false)
    const [dateOrderError, setDateOrderError] = useState(false)


    function addHours(date, hours) {
        date.setHours(date.getHours() + hours);

        return date;
    }

    const convertDate = (date) => {
        const formattedDate = new Intl.DateTimeFormat('en-GB', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            fractionalSecondDigits: 3,
            timeZone: 'UTC',
        }).format(date);

        return formattedDate
    }


    //ส่งฟอร์มการยืม
    const handleSubmit = async () => {
        try {
            if (data.equipment_id.length > 0) {
                let dataToFetch
                // setAlertModal(false)
                data.equipment_id.map(async element => {
                    dataToFetch = {
                        users_name_borrow: data.users_name_borrow,
                        users_id_borrow: data.users_id_borrow, //2023-12-01T11:23:08.000Z
                        date_borrow: data.date_borrow,
                        date_return: data.date_return,
                        equipment_id: String(element.value),
                        remark_borrow: data.remark_borrow,
                        status: 0,
                    }
                    await FetchAxiosPost("/api/borrow/equipment/save", dataToFetch, token)
                });
            }
            // else {
            // setAlertModal(true)
            // }
            else {
                const res = await axios.post(baseURL + `/api/borrow/equipment/save`,
                    {
                        users_name_borrow: data.users_name_borrow,
                        users_id_borrow: data.users_id_borrow, //2023-12-01T11:23:08.000Z
                        date_borrow: data.date_borrow,
                        date_return: data.date_return,
                        equipment_id: String(data.equipment_id[0]),
                        remark_borrow: data.remark_borrow ?? "",
                        remark_return: data.remark_return ?? "",
                        status: 0,
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    })
            }
            await toggleModal()
            setData({
                users_name_borrow: user.user_name,
                users_id_borrow: user.user_id,
                date_borrow: new Date(),
                date_return: new Date(),
                equipment_id: [],
                class_name: "",
                remark_borrow: "",
                status: 0,
            })
            setAlertModal(false)
            await getBorrowDataTable()
        } catch (err) {
            console.error(err);
        }
    };

    //ส่งการแก้ไขการยืม
    const handleUpdate = async (id) => {
        await axios
            .put(
                baseURL + `/api/borrow/equipment/${id}`,
                {
                    users_name_borrow: dataEdit?.users_name_borrow,
                    users_id_borrow: dataEdit?.users_id_borrow,
                    date_borrow: dataEdit?.date_borrow,
                    date_return: dataEdit?.date_return,
                    equipment_id: String(dataEdit?.equipment_id),
                    remark_borrow: String(dataEdit?.remark_borrow),
                    remark_return: String(dataEdit?.remark_return),
                    status: dataEdit?.status,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            .then(async (res) => {
                toggleModal();
                await getBorrowDataTable()
            })
            .catch((err) => {
                console.error(err);
            });
    };

    let thisEffect = async () => {
        const params = new URLSearchParams({
            page: 1,
            size: 100,
            "order[0]": "type_name",
            "order[1]": "ASC",
        });
        const equipment = await FetchAxiosGet("/api/equipment/type", token, params);
        let options = [];
        await equipment?.result?.map(async (x, idx) => {
            options.push({ value: idx + 1, label: x.type_name })
        })
        options = options.filter((obj, index, self) => {
            return index === self.findIndex((t) => (
                t.value === obj.value
            ));
        });
        setEquipmentClass(options)
    }

    const searchItem = async (value = undefined) => {
        let params = new URLSearchParams({
            page: currentpage,
            size: 10,
            "order[0]": "item_id",
            "order[1]": "ASC",
            "filter[item_condition][0]": "สภาพสมบูรณ์",
            // "filter[item_status][0]": "อนุมัติ",
            "filter[item_chvdeslngtha][0]": null,
            "filter[for_borrow][0]": "1",
            "filter[date_borrow][0]": data.date_borrow,
            "filter[date_return][0]": data.date_return,
            search: (value, inputSearch)
        });
        if (value !== undefined) {
            params.append("filter[type_name][0]", value)
        }
        const equipment = await FetchAxiosGet("/api/equipment/datatable", token, params);
        setDataInfo(equipment.info)
        params = new URLSearchParams({
            page: 1,
            size: 100,
            "order[0]": "created_date",
            "order[1]": "DESC",
            "filter[status][0]": 0,
            "filter[status][1]": 1
        });
        const uqinuqeEquipment = await FetchAxiosGet("/api/borrow/equipment/datatable", token, params)
        let subArray = []
        uqinuqeEquipment?.result.map(i => {
            subArray.push({ value: Number(i.equipment_id), status: i.status })
        })
        setCheckReplaceEquipment(subArray)
        let options = [];
        await equipment?.result?.map(async x => {
            options.push({ value: x.item_id, label: x.mdata_name, opdcid: x.item_format })
        })
        options = options.filter((obj, index, self) => {
            return index === self.findIndex((t) => (
                t.value === obj.value
            ));
        });
        setEquipment(options)
    }

    const { insert, setInsert } = useInsertConText();
    useEffect(() => {
        if (insert.task === "user_ผู้บังคับบัญชา") {
            setDataEdit({
                ...dataEdit,
                users_id_borrow: insert.insert_id,
                users_name_borrow: insert.insert_name
            })
        }
    }, [insert])


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (prevValue === inputSearchClass) {
                thisEffect();
                // searchItem(data.class_name)
                setTimeout(() => {
                    setMenuShow(false)
                }, 1000);
            }
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [inputSearchClass, prevValue]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (prevValue2 === searchChangeInput) {
                let params = new URLSearchParams({
                    page: 1,
                    size: 10,
                    "order[0]": "item_id",
                    "order[1]": "ASC",
                    "filter[item_id][0]": dataEdit?.equipment_id,
                });
                // thisEffect();
                // searchItem(data.class_name)
                serachChangeEquipment(params, dataEdit?.equipment_id, allEquipment)
                setTimeout(() => {
                    setMenuShow2(false)
                }, 1000);
            }
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [searchChangeInput, prevValue2]);

    useEffect(() => {
        setPrevValue(inputSearchClass);
        setMenuShow(true)
    }, [inputSearchClass]);

    useEffect(() => {
        setPrevValue2(searchChangeInput);
        setMenuShow2(true)
    }, [searchChangeInput]);

    useEffect(() => {
        thisEffect();
    }, [openBorrow]);

    const clearState = async () => {
        setData({
            users_name_borrow: user.user_name,
            users_id_borrow: user.user_id,
            date_borrow: "",
            date_return: "",
            equipment_id: [],
            class_name: "",
            remark_borrow: "",
            remark_return: "",
            status: 0,
        })
        setDataEdit({
            users_name_borrow: "",
            users_id_borrow: "",
            // users_name_borrow: user.user_name,
            // users_id_borrow: user.user_id,
            date_borrow: "",
            date_return: "",
            equipment_id: [],
            class_name: "",
            remark_borrow: "",
            remark_return: "",
            status: 0,
        })
        setAlertModal(false)
        setInputSearchClass("");
        setCheckEquipment(false);
        setEquipmentClass([]);
        setOpenModal(false)
        setInputSearch("");
        setKeyWord("");
        setEquipment([]);
        setSearchChangeInput("")
        setPrevValue(inputSearchClass);
        setPrevValue2(searchChangeInput);
        setMenuShow(false);
        setMenuShow2(false);
        setChangeEquipment([])
        setAllEquipment([])
        setCheckChangeEquipment(false)
        setCheckReplaceEquipment([])
        setDataInfo(null)
    }

    const setDateBorrow = (e) => {
        if (modalState === "add") {
            setValidatedObj((prev) => ({ ...prev, valid_dateBorw: e }));
            setData((prev) => ({ ...prev, date_borrow: e }));
        } else if (modalState === "edit") {
            setDataEdit({
                ...dataEdit,
                date_borrow: e,
            })
        }
    }

    const setDateReturn = (e) => {
        if (modalState === "add") {
            setValidatedObj((prev) => ({ ...prev, valid_dateRetrn: e }));
            setData((prev) => ({ ...prev, date_return: e }));
        } else if (modalState === "edit") {
            setDataEdit({
                ...dataEdit,
                date_return: e,
            })
        }
    }

    const setDateBorrowObj = (e) => {
        setValidatedObj((prev) => ({ ...prev, valid_dateRetrn: e }));
    }

    const setDateReturnObj = (e) => {
        setData((prev) => ({ ...prev, date_return: e }));
    }

    useEffect(() => {
        const borrow = modalState === "add" ? data.date_borrow : dataEdit?.date_borrow;
        const ret = modalState === "add" ? data.date_return : dataEdit?.date_return;
        setDateOrderError(!!borrow && !!ret && new Date(borrow) >= new Date(ret));
    }, [data.date_borrow, data.date_return, dataEdit?.date_borrow, dataEdit?.date_return, modalState]);

    useEffect(() => {
        if (data.class_name !== "") {
            searchItem(data.class_name)
        }
    }, [data, currentpage])

    useEffect(() => {
        setDataloading(true)
        searchItem(data.class_name)
        setTimeout(() => {
            setDataloading(false)
        }, 1000);

    }, [currentpage])


    useEffect(() => {
        validatedObj?.valid_dateBorw && validatedObj?.valid_dateRetrn && validatedObj?.valid_item && setSubmit(true)
    }, [validatedObj])

    const toggleModalEquipment = () => {
        // setOpenModal(!openModal)
        setOpenModal(false)
        setInputSearch("")
        setCurrentpage(1)
    }

    useEffect(() => {
        searchItem(data.class_name)
    }, [inputSearch])

    const waitForFetch = async (value) => {
        setInputSearch(keyWord)
    }

    const serachChangeEquipment = async (params, value1, value2) => {
        params.append("filter[type_name][0]", value2[0]?.type_name)
        params.append("filter[item_condition][0]", "สภาพสมบูรณ์")
        params.append("filter[for_borrow][0]", "1")
        params.append("filter[date_borrow][0]", dataEdit?.date_borrow)
        params.append("filter[date_return][0]", dataEdit?.date_return)
        params.delete("filter[item_id][0]", value1)
        if (searchChangeInput !== "") {
            params.append("search", searchChangeInput)
        }
        const fetchChangeEquipment = await FetchAxiosGet("/api/equipment/datatable", token, params)
        let options = [];
        await fetchChangeEquipment?.result?.map(async x => {
            options.push({ value: x.item_id, label: `${x.mdata_name} : ${x.item_format}` })
        })
        options = options.filter((obj, index, self) => {
            return index === self.findIndex((t) => (
                t.value === obj.value
            ));
        });
        options = options.filter(opt => Number(opt.value) !== Number(value1));
        setChangeEquipment(options)
    }

    const letEquipmentName = async (id) => {
        let params = new URLSearchParams({
            page: 1,
            size: 10,
            "order[0]": "item_id",
            "order[1]": "ASC",
            "filter[item_id][0]": id,
        });
        const fetchEquipment = await FetchAxiosGet("/api/equipment/datatable", token, params)
        setAllEquipment(fetchEquipment.result)
        serachChangeEquipment(params, id, fetchEquipment.result)
    }

    useEffect(() => {
        if (dataEdit?.equipment_id.length > 0) { letEquipmentName(dataEdit?.equipment_id) }
    }, [dataEdit])

    useEffect(() => {
        if (data?.equipment_id?.length === 30) {
            toggleModalEquipment()
        }
    }, [data])

    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (data?.equipment_id.length === 30) {
            setOpenModal(false)
        }
    }, [data?.equipment_id])


    return (
        <Modal centered isOpen={openBorrow} size="lg" toggle={() => { toggleModal(); clearState() }}>
            <ModalHeader>
                {modalState === "add"
                    ? "เพิ่มการยืมครุภัณฑ์"
                    : modalState === "edit"
                        ? "แก้ไขข้อมูล"
                        : "รายละเอียดข้อมูล"}
                <div className="position-absolute top-0 end-0">
                    <i className="fa-sharp fa-solid fa-circle-xmark pt-3 pe-3 h4" style={{ cursor: "pointer" }} onClick={() => { toggleModal(); clearState() }}></i>
                </div>
            </ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup row>
                        <Label className="text-end" xs={4} md={4} lg={4} xxl={4}>
                            <span className="text-danger">*</span>  ผู้ใช้งาน
                        </Label>
                        <Col xs={7} md={7} lg={7} xxl={7}>
                            {(filterSubAdmin?.length > 0 && (Number(filterSubAdmin) === 0 || Number(filterSubAdmin) === 4))
                                ? modalState === "view" ?
                                    <InputGroup>
                                        <Input
                                            disabled
                                            defaultValue={dataEdit?.users_name_borrow}
                                            name="user_name"
                                            placeholder=""
                                            type="text"
                                            invalid={!dataEdit?.users_name_borrow}
                                        />
                                        {/* <ModalUser task="user_ผู้บังคับบัญชา" /> */}
                                    </InputGroup>
                                    :
                                    <InputGroup>
                                        <Input
                                            readOnly
                                            defaultValue={dataEdit?.users_name_borrow}
                                            name="user_name"
                                            placeholder=""
                                            type="text"
                                            invalid={!dataEdit?.users_name_borrow}
                                        />
                                        <ModalUser task="user_ผู้บังคับบัญชา" showSelectedAllMenu={true} />
                                    </InputGroup>
                                :
                                <Input
                                    type="text"
                                    value={
                                        modalState === "add"
                                            ? data.users_name_borrow
                                            : dataEdit?.users_name_borrow
                                    }
                                    disabled
                                    onChange={(e) => {
                                        setDataEdit({
                                            ...dataEdit,
                                            users_id_borrow: dataEdit?.users_id_borrow,
                                            users_name_borrow: e.target.value
                                        })
                                    }}
                                />
                            }
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label className="text-end" xs={4} md={4} lg={4} xxl={4}>
                            <span className="text-danger">*</span>  วันที่ยืม
                        </Label>
                        <Col xs={7} md={7} lg={7} xxl={7}>
                            <MyDatePicker isDisable={modalState === "view" ? true : false}
                                showInitialValue={modalState === "edit" || modalState === "view" ? true : false}
                                initialDate={modalState === "edit" || modalState === "view" ? dataEdit?.date_borrow : new Date()} setProbsDate={setDateBorrow} setDateObj={setDateBorrowObj} rounded={"rounded-2 w-100"} />
                            {modalState === "add" && !validatedObj.valid_dateBorw ? <div style={{ color: 'red', fontSize: '12px' }}>กรุณาเลือกวันที่</div> : ""}
                            {/* <NewThaiDatePicker value={data.date_borrow} setValue={setDateBorrow} placeholderText="วัน/เดือน/ปี"/> */}
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label className="text-end" xs={4} md={4} lg={4} xxl={4}>
                            <span className="text-danger">*</span>  กำหนดคืน
                        </Label>
                        <Col xs={7} md={7} lg={7} xxl={7}>
                            <MyDatePicker
                                isDisable={modalState === "view" ? true : (modalState === "add" && !validatedObj.valid_dateBorw)}
                                showInitialValue={modalState === "edit" || modalState === "view" ? true : false}
                                initialDate={modalState === "edit" || modalState === "view" ? dataEdit?.date_return : new Date()}
                                setDateObj={setDateReturn}
                                rounded={"rounded-2 w-100"}
                                minDate={modalState === "edit" || modalState === "view" ? dataEdit?.date_borrow : data.date_borrow}
                            />
                            {modalState === "add" && !validatedObj.valid_dateRetrn ? <div style={{ color: 'red', fontSize: '12px' }}>กรุณาเลือกวันที่</div> : ""}
                            {modalState !== "view" && dateOrderError ? <div style={{ color: 'red', fontSize: '12px' }}>วันที่ยืมต้องน้อยกว่าวันที่คืน กรุณาตรวจสอบวันที่อีกครั้ง</div> : ""}
                            {/* <NewThaiDatePicker value={data.date_return} setValue={setDateReturn} placeholderText="วัน/เดือน/ปี" minDate={data.date_borrow}/> */}
                        </Col>
                    </FormGroup>
                    {modalState !== "view" &&
                        <FormGroup row>
                            <Label className="text-end" xs={4} md={4} lg={4} xxl={4}>
                                <span className="text-danger">*</span>  ประเภทครุภัณฑ์
                            </Label>
                            <Col xs={7} md={7} lg={7} xl={7}>
                                <InputGroup>
                                    <Select
                                        styles={{
                                            option: (styles, { isSelected }) => ({
                                                ...styles,
                                                backgroundColor: isSelected ? '#556ee6' : '#f5f5f5',
                                                ':active': {
                                                    ...styles[':active'],
                                                    backgroundColor: '#556ee6',
                                                },
                                                ':hover': {
                                                    ...styles[':hover'],
                                                    backgroundColor: '#556ee6',
                                                    color: '#fff'
                                                }
                                            }),
                                            menu: styles => ({
                                                ...styles,
                                                backgroundColor: '#f5f5f5',
                                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)'
                                            })

                                        }}
                                        className="basic-single w-75"
                                        classNamePrefix="ครุภัณฑ์"
                                        isDisabled={(modalState === "view" || modalState === "edit") && true}
                                        defaultValue={
                                            modalState === "add"
                                                ? equipmentClass?.find(x => x.value === Number(data?.class_name))
                                                : equipmentClass?.find(x => x.value === Number(dataEdit?.class_name))
                                        }
                                        isSearchable={true}
                                        noOptionsMessage={() => "ไม่พบครุภัณฑ์ดังกล่าว"}
                                        loadingMessage={() => "กำลังดาวน์โหลดข้อมูล"}
                                        name="color"
                                        placeholder="ครุภัณฑ์"
                                        isLoading={menuShow}
                                        options={equipmentClass}
                                        onInputChange={(e) => { setInputSearchClass(e) }}
                                        onChange={(e) => {
                                            if (modalState === "add") {
                                                setData((prev) => ({ ...prev, class_name: e?.label }))
                                            } else if (modalState === "edit") {
                                                setDataEdit({ ...dataEdit, class_name: e?.label })
                                            }
                                            setCheckEquipment(true)
                                        }}
                                    />
                                    <Button className="w-25 z-0" style={{ whiteSpace: "nowrap" }} disabled={!checkEquipment || modalState === "edit" || data?.equipment_id.length === 30} onClick={() => { setOpenModal(true) }}>
                                        {windowSize.width < 576 || (windowSize.width >= 576 && windowSize.width < 992) ? <i className="fa-solid fa-toolbox"></i> : "กดเลือกอุปกรณ์"}
                                    </Button>
                                </InputGroup>
                                {modalState === "add" && !validatedObj.valid_item ? <div style={{ color: 'red', fontSize: '12px' }}>กรุณาเลือกครุภัณฑ์</div> : ""}
                            </Col>
                        </FormGroup>
                    }

                    <Modal isOpen={openModal} toggle={toggleModalEquipment} centered style={{ maxWidth: "550px" }}>
                        <ModalHeader toggle={toggleModalEquipment}>จองครุภัณฑ์</ModalHeader>
                        <ModalBody>
                            {dataloading
                                ?
                                <LoadingData />
                                :
                                <Fragment>
                                    <InputGroup className="mb-3">
                                        <Input
                                            placeholder="ค้นหาครุภัณฑ์..."
                                            value={keyWord}
                                            onChange={(e) => { setKeyWord(e.target.value) }}
                                            onKeyUp={e => waitForFetch()}
                                        />
                                        <Button color="danger"
                                            onClick={() => {
                                                setKeyWord('');
                                                waitForFetch()
                                            }}>
                                            <i className="fa-solid fa-magnifying-glass-minus"></i>
                                        </Button>
                                    </InputGroup>
                                    {equipment.length > 0 ? equipment.map((x, idx) => {
                                        const checkStatus = checkReplaceEquipment.find(i => i.value === Number(x.value))
                                        return (
                                            // checkStatus ?
                                            //     <div key={idx}>
                                            //         <InputGroup className="w-100 mb-2 d-flex justify-content-center">
                                            //             <ListGroup className="border border-1" style={{ width: '92%', borderColor: '#ced4da !important' }}>
                                            //                 <ListItem className="pb-0">{x.label}</ListItem>
                                            //                 <ListItem className="pt-0 b-0">
                                            //                     <span className="text-primary" style={{ fontSize: "12px" }}>{x.opdcid}</span>
                                            //                 </ListItem>
                                            //             </ListGroup>
                                            //             <InputGroupText style={{ width: '8%' }} className={`${checkStatus.status === 0 ? "bg-primary " : checkStatus.status === 1 && "bg-success"} text-white justify-content-center`}>
                                            //                 {checkStatus.status === 0 ? "จอง" : checkStatus.status === 1 && "ยืม"}
                                            //             </InputGroupText>
                                            //         </InputGroup>
                                            //     </div>
                                            //     :
                                            <Fragment key={idx}>
                                                <InputGroup className="w-100 mb-2 d-flex justify-content-center">
                                                    <ListGroup className="border border-1" style={{ width: '92%', borderColor: '#ced4da !important' }}>
                                                        <ListItem className="pb-0">{x.label}</ListItem>
                                                        <ListItem className="pt-0 b-0">
                                                            <span className="text-primary" style={{ fontSize: "12px" }}>{x.opdcid}</span>
                                                        </ListItem>
                                                    </ListGroup>
                                                    <InputGroupText className="border border-1" style={{ width: '8%', borderColor: '#ced4da !important' }}>
                                                        <Input
                                                            defaultChecked={data?.equipment_id?.some(item => item.value === x.value)}
                                                            addon
                                                            type="checkbox"
                                                            onChange={(e) => {
                                                                setValidatedObj((prev) => ({ ...prev, valid_item: e }));
                                                                if (e.target.checked) {
                                                                    setData((prev) => ({ ...prev, equipment_id: [...prev.equipment_id, { value: x?.value, label: x?.label, opdcid: x?.opdcid }] }))
                                                                } else {
                                                                    setData((prev) => ({ ...prev, equipment_id: prev.equipment_id.filter(item => item.value !== x?.value) }));
                                                                }
                                                            }}
                                                        />
                                                    </InputGroupText>
                                                </InputGroup>
                                            </Fragment>

                                        )
                                    }) : <span className="text-center flex-grow-1 d-flex align-items-center justify-content-center fs-5">ไม่พบข้อมูลครุภัณฑ์</span>
                                    }
                                    <Row className="mt-2">
                                        <Col xs={6} md={6} lg={6} xxl={6}>
                                            <span className="ps-2">
                                                {dataInfo?.pageSize >= dataInfo?.totalRows ? dataInfo?.totalRows : dataInfo?.pageSize} รายการ จากทั้งหมด {dataInfo?.totalRows} รายการ
                                            </span>
                                        </Col>
                                        <Col xs={6} md={6} lg={6} xxl={6} className="d-flex justify-content-end">
                                            <Pagination>
                                                <PaginationItem disabled={currentpage == 1 || dataInfo?.totalPage == 0}>
                                                    <PaginationLink
                                                        onClick={() => (setCurrentpage(currentpage - 1))}
                                                        previous
                                                    />
                                                </PaginationItem>
                                                <PaginationItem active>
                                                    <PaginationLink>หน้า {currentpage} จาก {dataInfo?.totalPage}</PaginationLink>
                                                </PaginationItem>
                                                <PaginationItem disabled={currentpage == dataInfo?.totalPage || dataInfo?.totalPage == 0}>
                                                    <PaginationLink
                                                        onClick={() => (setCurrentpage(currentpage + 1))}
                                                        next
                                                    />
                                                </PaginationItem>
                                            </Pagination>
                                        </Col>
                                    </Row>
                                </Fragment>
                            }

                        </ModalBody>
                    </Modal>

                    {(data?.equipment_id.length > 0 || modalState === "edit" || modalState === "view") &&
                        <FormGroup row>
                            <Label className="text-end" xs={4} md={4} lg={4} xxl={4}>
                                รายการครุภัณฑ์ที่เลือก
                            </Label>
                            {modalState === "add" ?
                                <Fragment>
                                    {
                                        data?.equipment_id.map((y, idx) => {
                                            return (
                                                <Fragment key={idx}>
                                                    {idx > 0 && <Col xs={4} md={4} lg={4} xxl={4} />}
                                                    <Col xs={7} md={7} lg={7} xl={7}>
                                                        <InputGroup className="mb-2">
                                                            {/* <Input value={y.label} /> */}
                                                            <div className="border rounded p-2" style={{ width: '91%' }}>
                                                                {y.label}
                                                                <p class="text-info m-0 font-weight-bold" style={{ fontSize: '11px' }}>{y.opdcid}</p>
                                                            </div>
                                                            <Button color="danger" onClick={() => { setData((prev) => ({ ...prev, equipment_id: prev.equipment_id.filter(item => item.value !== y?.value) })); }}>
                                                                <i className="fa-solid fa-trash"></i>
                                                            </Button>
                                                        </InputGroup>

                                                    </Col>
                                                </Fragment>
                                            )
                                        })
                                    }
                                    {data?.equipment_id.length > 0 && <Col xs={4} md={4} lg={4} xxl={4} />}
                                    <Col xs={7} md={7} lg={7} xl={7}>
                                        {data?.equipment_id.length} รายการ จากการยืมได้ทั้งหมด 30 รายการ
                                    </Col>
                                </Fragment>
                                : modalState === "edit" ?
                                    (allEquipment.length > 0 &&
                                        <Fragment>
                                            <Col xs={7} md={7} lg={7} xl={7}>
                                                <InputGroup className="mb-2">
                                                    <Input defaultValue={`${allEquipment[0]?.mdata_name} : ${allEquipment[0]?.item_format}`} readOnly />
                                                </InputGroup>
                                            </Col>
                                            <Col xs={4} md={4} lg={4} xl={4} />
                                            <Col xs={7} md={7} lg={7} xl={7}>
                                                <InputGroup className="mb-2">
                                                    <InputGroupText>
                                                        <Input addon type="checkbox" onChange={(e) => { setCheckChangeEquipment(e.target.checked) }} />
                                                    </InputGroupText>
                                                    <Input defaultValue="เปลี่ยนครุภัณฑ์" />
                                                </InputGroup>
                                            </Col>
                                            {checkChangeEquipment &&
                                                <Fragment>
                                                    <Col xs={4} md={4} lg={4} xl={4} />
                                                    <Col xs={7} md={7} lg={7} xl={7}>
                                                        <Select
                                                            className="basic-single w-100"
                                                            classNamePrefix="ครุภัณฑ์"
                                                            // isDisabled={(modalState === "view" || modalState === "edit")&& true}
                                                            defaultValue={changeEquipment?.find(x => x.value === Number(dataEdit?.equipment_id))}
                                                            noOptionsMessage={() => "ไม่พบครุภัณฑ์ดังกล่าว"}
                                                            loadingMessage={() => "กำลังดาวน์โหลดข้อมูล"}
                                                            name="color"
                                                            placeholder="ครุภัณฑ์"
                                                            isLoading={menuShow2}
                                                            options={changeEquipment}
                                                            onInputChange={(e) => { setSearchChangeInput(e) }}
                                                            onChange={(e) => {
                                                                if (modalState === "edit") {
                                                                    setDataEdit({ ...dataEdit, equipment_id: e?.value })
                                                                }
                                                                setCheckEquipment(true)
                                                            }}
                                                        />
                                                    </Col>
                                                </Fragment>}
                                        </Fragment>
                                    )
                                    : modalState === "view" &&
                                    <Col xs={7} md={7} lg={7} xl={7}>
                                        <InputGroup className="mb-2">
                                            <Input value={`${allEquipment[0]?.mdata_name} : ${allEquipment[0]?.item_format}`} disabled />
                                        </InputGroup>
                                    </Col>
                            }
                        </FormGroup>
                    }
                    <FormGroup row className="mt-2">
                        <Label className="text-end" xs={4} md={4} lg={4} xxl={4}>
                            <span className="text-danger">*</span>  เพื่อใช้งาน
                        </Label>
                        <Col xs={7} md={7} lg={7} xl={7}>
                            <Input
                                style={{ height: "75px" }}
                                type="textarea"
                                defaultValue={dataEdit?.remark_borrow ?? null}
                                placeholder="สำหรับใช้งาน....."
                                disabled={modalState === "view" ? true : false}
                                onChange={(e) => {
                                    if (modalState === "add") {
                                        setData((prev) => ({ ...prev, remark_borrow: e.target.value }))
                                    } else if (modalState === "edit") {
                                        setDataEdit({ ...dataEdit, remark_borrow: e.target.value })
                                    }
                                }}
                            />
                        </Col>
                    </FormGroup>
                    {modalState === "view" &&
                        <>
                            <FormGroup row>
                                <Label className="text-end" xs={4} md={4} lg={4} xxl={4}>
                                    ผู้จ่าย
                                </Label>
                                <Col xs={7} md={7} lg={7} xxl={7}>
                                    <InputGroup>
                                        <Input
                                            disabled
                                            defaultValue={dataEdit?.status == 0 ? "-" : dataEdit?.user_name_allot == null ? "-" : dataEdit?.user_name_allot}
                                            name="user_name"
                                            placeholder=""
                                            type="text"
                                        />
                                    </InputGroup>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label className="text-end" xs={4} md={4} lg={4} xxl={4}>
                                    ผู้มารับ
                                </Label>
                                <Col xs={7} md={7} lg={7} xxl={7}>
                                    <InputGroup>
                                        <Input
                                            disabled
                                            defaultValue={dataEdit?.status == 0 ? "-" : dataEdit?.users_name_borrow == null ? "-" : dataEdit?.users_name_borrow}
                                            name="user_name"
                                            placeholder=""
                                            type="text"
                                        />
                                    </InputGroup>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label className="text-end" xs={4} md={4} lg={4} xxl={4}>
                                    ผู้รับคืน
                                </Label>
                                <Col xs={7} md={7} lg={7} xxl={7}>
                                    <InputGroup>
                                        <Input
                                            disabled
                                            defaultValue={dataEdit?.status == 0 ? "-" : dataEdit?.user_name_repatriate == null ? "-" : dataEdit?.user_name_repatriate}
                                            name="user_name"
                                            placeholder=""
                                            type="text"
                                        />
                                    </InputGroup>
                                </Col>
                            </FormGroup>
                            <FormGroup row>
                                <Label className="text-end" xs={4} md={4} lg={4} xxl={4}>
                                    ผู้คืน
                                </Label>
                                <Col xs={7} md={7} lg={7} xxl={7}>
                                    <InputGroup>
                                        <Input
                                            disabled
                                            defaultValue={dataEdit?.status == 0 ? "-" : dataEdit?.users_name_returner == null ? "-" : dataEdit?.users_name_returner}
                                            name="user_name"
                                            placeholder=""
                                            type="text"
                                        />
                                    </InputGroup>
                                </Col>
                            </FormGroup>
                        </>
                    }
                    <FormGroup row className="mt-2">
                        <Label className="text-end" xs={4} md={4} lg={4} xxl={4}>
                            หมายเหตุ
                        </Label>
                        <Col xs={7} md={7} lg={7} xxl={7}>
                            <Input
                                defaultValue={dataEdit?.remark_return == "null" ? "" : dataEdit?.remark_return}
                                disabled={modalState === "view" ? true : false}
                                onChange={(e) => {
                                    if (modalState === "add") {
                                        setData((prev) => ({ ...prev, remark_return: e.target.value }))
                                    } else if (modalState === "edit") {
                                        setDataEdit({ ...dataEdit, remark_return: e.target.value })
                                    }
                                }}
                            />
                        </Col>
                    </FormGroup>
                </Form>
                <Row>
                    <Col xs={3} md={3} lg={3} xxl={3}></Col>
                    <Col xs={8} md={8} lg={8} xl={8}>
                        <Alert className="d-flex justify-content-center" style={{ width: "500px" }} color="danger" isOpen={alertModal}>กรุณากรอกข้อมูลให้ครบ</Alert>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                {modalState === "add" || modalState === "edit" ?
                    <Button
                        disabled={
                            modalState === "add" ?
                                data.date_borrow === "" ||
                                data.date_return === "" ||
                                data.equipment_id === undefined ||
                                data.remark_borrow === "" ||
                                dateOrderError
                                : dateOrderError
                        }
                        className=""
                        type="submit"
                        color={modalState === "add" ? "success" : "warning"}
                        onClick={async (e) => {
                            e.preventDefault();
                            if (modalState === "add" && submit) {
                                await handleSubmit();
                            } else if (modalState === "edit") {
                                await handleUpdate(dataEdit?.id);
                            } else {
                                setAlertModal(true)
                            }
                        }}
                    >
                        {modalState === "add" ? "บันทึก" : "แก้ไข"}
                    </Button> : null
                }
                <Button color="danger" onClick={toggleModal} className="me-2">
                    ปิด
                </Button>
            </ModalFooter>
        </Modal >
    );
};

export default ModalBorrowTable;
